import { render } from "./PinoButton.vue?vue&type=template&id=568acc7c&scoped=true"
import script from "./PinoButton.vue?vue&type=script&lang=js"
export * from "./PinoButton.vue?vue&type=script&lang=js"

import "./PinoButton.vue?vue&type=style&index=0&id=568acc7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568acc7c"]])

export default __exports__